// submenudatasharing.service.ts
import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SiblingSignalService {
  // store submenu items (empty array by default)
  readonly data = signal<any[]>([]);

  emitData(value: any[]) {
    console.log('Service emitData called with:', value);
    this.data.set(value ?? []);
    console.log('Service internal value now:', this.data());
  }

  clear() {
    this.data.set([]);
  }
}
